import { oc } from '@orpc/contract';
import { z } from 'zod';
import areYouOk, { statusUpdate } from './are-you-ok.dto';
import { areYouOkChannel } from './are-you-ok-channel.dto';
import opened from './opened/opened.dto';
import { areYouOkPendingResponse, setResponse } from './pending/pending.dto';

const id = z.string();
const inputId = z.object({ id });

export const areYouOkContract = {
  byId: oc
    .route({
      method: 'GET',
      path: '/are-you-ok/{id}',
      summary: 'Get status of are you ok',
    })
    .input(inputId)
    .output(areYouOk),

  setStatus: oc
    .route({
      method: 'PATCH',
      path: '/are-you-ok/{id}',
      summary: 'Set status of are you ok',
    })
    .input(z.object({ id, status: statusUpdate, channel: areYouOkChannel }))
    .output(areYouOk),

  setOpened: oc
    .route({
      method: 'PUT',
      path: '/are-you-ok/{id}/opened',
      summary: 'Set opened when safety check visible to the user',
    })
    .input(z.object({ id, channel: areYouOkChannel }))
    .output(opened),

  setPendingResponse: oc
    .route({
      method: 'PUT',
      path: '/are-you-ok/{id}/pendingResponse',
      summary: 'Set pending response',
    })
    .input(z.object({ id, response: setResponse, channel: areYouOkChannel }))
    .output(areYouOkPendingResponse),

  deletePendingResponse: oc
    .route({
      method: 'DELETE',
      path: '/are-you-ok/{id}/pendingResponse',
      summary: 'Remove pending response',
    })
    .input(inputId)
    .output(areYouOkPendingResponse),
};

export default areYouOkContract;
